<template>
  <div>
    <ods-dialog
      :visible.sync="dialogWarning"
      :append-to-body="true"
      :before-close="closeDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
      center
      width="500px">
      <img v-if="dialogError" :src="require('@/assets/icons/atencion_dimension.svg')"
              alt="Error" class="picto-dato">
      <img v-else :src="require('@/assets/icons/picto_datos.svg')"
              alt="Error" class="picto-dato">
      <span>
        <p class="problemas-con-el-ser">{{ message }}</p>
      </span>
      <span slot="footer">
        <ods-button class="cancel-button"
          type="primary"
          @click="closeDialog">
          {{ labelCancelButton }}
        </ods-button>
      </span>
    </ods-dialog>
  </div>
</template>

<script>
export default {
  name: 'DialogGenericWarning',
  props: {
    message: {
      type: String,
      required: true
    },
    dialogWarning: {
      type: Boolean,
      default: false
    },
    labelCancelButton: {
      type: String,
      default: function () { return 'ACEPTAR' }
    },
    dialogError: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeDialog () {
      this.$emit('dialogClosed', false)
    }
  }
}
</script>

<style lang="scss" scoped>
 .dialog-text {
    margin-bottom: rem(20);
    font-size: rem(14);
 }

 .img--style {
   width: rem(70);
   height: rem(44);
   margin-top: rem(78);
 }

 .problemas-con-el-ser {
  height: 26px;
  color: #060E14;
  font-size: 18px;
  letter-spacing: 0;
  line-height: 26px;
  text-align: center;
  padding-top: 25px;
 }

 .picto-datos {
    height: 68px;
    width: 114px;
 }
 .ods-dialog__body{
   img{
     width: 114px;
   }
 }
</style>
